// extracted by mini-css-extract-plugin
var _1 = "FileMove_modalBody__c6402";
var _2 = "FileMove_projectTable__e049c";
export { _1 as "modalBody", _2 as "projectTable" }
